import { useMutation } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useEvaluateStep = () => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useMutation({
    mutationFn: async ({ challengeId, action, challengeToDo }) => {
      const result = await restClient({
        url: `${prefix}/challenge/${challengeId}/evaluate-step`,
        method: 'post',
        data: {
          action,
          challengeToDo
        }
      });
      return result;
    },
  });
};